import { PercentageValue } from "../../../percentage_value";

type AvailabilityCellProps = {
  value: string | undefined;
};

export const AvailabilityCell = ({ value }: AvailabilityCellProps) => (
  <PercentageValue value={value} isNormalized />
);
